/**
 * Finds external contour of the roi from its mask.
 * @param roi - roi to find contour from.
 * @param options - GetExternalContourOptions.
 * @returns Array of contour points.
 */
export function getExternalContour(roi, options) {
    const mask = roi.getMask();
    return mask.getExternalContour(options);
}
//# sourceMappingURL=getExternalContour.js.map